module.exports = __webpack_public_path__ + "static/media/006_Live.b906697e.mp4";